import axios from "axios";
import { getCookie, deleteCookies } from "@/utils/cookie";
import router from "@/router";
const domain = process.env.VUE_APP_API_URL.trim();

const axiosInstance = axios.create({
  baseURL: domain,
});

// Axios 응답 인터셉터
axiosInstance.interceptors.response.use(
  (response) => response, // 성공적인 응답
  (error) => {
    if (error.response && error.response.status === 401) {
      deleteCookies(); // 쿠키 삭제
      alert("로그인 토큰이 만료되었습니다.");
      router.push("/"); // 홈 화면으로 이동
    }
    return Promise.reject(error);
  }
);

// 요청 방법
const request = {
  get(path, header) {
    return axiosInstance
      .get(`${domain + path}`, header)
      .catch((e) => console.error(e));
  },
  post(path, data, header) {
    return axiosInstance
      .post(`${domain + path}`, data, header)
      .catch((e) => console.error(e));
  },
  put(path, data, header) {
    return axiosInstance
      .put(`${domain + path}`, data, header)
      .catch((e) => console.log(e));
  },
  delete(path, header) {
    return axiosInstance
      .delete(`${domain + path}`, header)
      .catch((e) => console.error(e));
  },
};

export const admin = {
  login(adminData) {
    return request.post("/admin/account/login", adminData).then(({ data }) => data);
  },
  logout() {
    return request
      .delete("/admin/account/logout", {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  medicalRead(adminData) {
    return request
      .get(
        // `/admin/medical-team/read?query=${adminData.query}&start=${adminData.start}&size=${adminData.size}`,
        `/admin/medical-team?name=${adminData.query}&start=${adminData.start}&size=${adminData.size}`,
        {
          headers: {
            Authorization: "Bearer " + getCookie("token"),
          },
        }
      )
      .then(({ data }) => data);
  },
  medicalUpdate(adminData) {
    return request
      .put("/admin/medical-team", adminData, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  medicalCreate(adminData) {
    return request
      .post("/admin/medical-team", adminData, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  medicalDelete(adminData) {
    return request
      .delete(`/admin/medical-team/${adminData.mtid}`, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  patientRead(adminData) {
    let getUrl = `/admin/patient?start=${adminData.start}&size=${adminData.size}`;
    if (adminData.query.length > 0) getUrl += `&patient_name=${adminData.query}`;
    if (adminData.status) getUrl += `&status=${adminData.status}`;
    if (adminData.hos_start) getUrl += `&hos_start=${adminData.hos_start}`;
    if (adminData.hos_end) getUrl += `&hos_end=${adminData.hos_end}`;
    // `/admin/patient/read?query=${if adminData.query}&status=${adminData.status}&hos_start=${adminData.hos_start}&hos_end=${adminData.hos_end}&start=${adminData.start}&size=${adminData.size}`
    return request
      .get(`${getUrl}`, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  patientUpdate(adminData) {
    return request
      .put("/admin/patient", adminData, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  patientCreate(adminData) {
    return request
      .post("/admin/patient", adminData, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  wardList() {
    return request
      .get("/admin/ward", {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  teamList(adminData) {
    return request
      .get(`/admin/ward/teams?wid=${adminData}`, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  roomList(adminData) {
    return request
      .get(`/admin/ward/rooms?wid=${adminData}`, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
};

export const dressing = {
  dressingRead() {
    return request
      .get("/admin/dressing", {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
        },
      })
      .then(({ data }) => data);
  },
  // dressingImgRead(filename) {
  //   return request
  //     .get(`/admin/dressing/img/${filename}`, {
  //       headers: {
  //         Authorization: "Bearer " + getCookie("token"),
  //       },
  //       responseType: "blob",
  //     })
  //     .then(({ data }) => data);
  // },
  dressingImgRead(filename) {
    return axiosInstance.get(`/admin/dressing/img/${filename}`, {
      headers: {
        Authorization: "Bearer " + getCookie("token"),
      },
      responseType: "blob",
      validateStatus: (status) => {
        return status === 200 || status === 404;
      },
    }).then((response) => {
      if (response.status === 404) {
        return null; // 이미지 없음
      }
      return response.data;
    });
  },
  uploadeImg(form) {
    return request
      .post(`/admin/dressing`, form, {
        headers: {
          Authorization: "Bearer " + getCookie("token"),
          "Content-Type": "multipart/form-data",
        },
        contentType: "multipart/form-data",
      })
      .then(({ data }) => data);
  },
  // uploadeImg(fileData, form) {
  //   return request
  //     .post(`/admin/dressing/upload_img/${fileData}`, form, {
  //       headers: {
  //         Authorization: "Bearer " + getCookie("token"),
  //         "Content-Type": "multipart/form-data",
  //       },
  //       contentType: "multipart/form-data",
  //     })
  //     .then(({ data }) => data);
  // },
};
